<main class="main">
    <div class="container">
        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Regulators Crawled Data List</h1>
        </div>
        <div class="card-body">
            <form #filterForm="ngForm" class="navbar-form" class="form-floating">
                <div class="row m-0 searchRecordWrapper">
                    <p class="error textError m-0" *ngIf="errorMessage!=null">
                        {{errorMessage}}
                    </p>

                    <!-- Client Master Name - REQUIRED -->
                    <div class="col-4 mt-4">
                        <div class="form-floating">
                            <select class="form-select form-control" id="txtClientMasterId"
                                aria-label="Floating label select example" [(ngModel)]="clientMasterId"
                                name="clientMasterId" #clientMasterIdField="ngModel" required
                                [class.is-invalid]="clientMasterIdField.invalid && clientMasterIdField.touched">
                                <!-- <option selected disabled [ngValue]="null"></option> -->
                                <option [value]="data?.ClientMasterID" *ngFor="let data of clientMasterOptionsList"
                                [hidden]="data?.ClientMasterID === 3 || data?.ClientMasterID === 4">
                                    {{data?.ClientName}}</option>
                            </select>
                            <label for="txtClientMasterId">Client Master Name <span class="text-danger">*</span></label>
                            <div class="invalid-feedback"
                                *ngIf="clientMasterIdField.invalid && clientMasterIdField.touched">
                                Client Master Name is required
                            </div>
                        </div>
                    </div>

                    <!-- Master Sheet Id -->
                    <div class="col-4 mt-4">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="txtDocId" min="0" placeholder="MasterSheetID"
                                name="MasterSheetID" [(ngModel)]="pagination.masterSheetId"
                                [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">Master Sheet Id</label>
                        </div>
                        <p *ngIf="validationError" class="text-danger mt-2">{{ validationError }}</p>
                    </div>

                    <!-- URLConfiguration Master Id -->
                    <div class="col-4 mt-4">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="txtDocId" min="0"
                                placeholder="URLConfigurationMasterID" name="URLConfigurationMasterID"
                                [(ngModel)]="pagination.UrlDetailID" [ngModelOptions]="{standalone: true}">
                            <label for="txtDocId">URLConfiguration Master Id</label>
                        </div>
                    </div>
                    <!-- From Date - REQUIRED -->
                    <div class="col-4 mt-4">
                        <div class="form-floating datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}"
                                [(ngModel)]="pagination.startDate" name="startDate" #startDateField="ngModel" required
                                [class.is-invalid]="startDateField.invalid && startDateField.touched" #s2="bsDatepicker"
                                readonly>
                            <label for="txtUrl">From Date <span class="text-danger">*</span></label>
                            <span class="input-group-text" (click)="s2.toggle()"><i class="fa fa-calendar"></i></span>
                            <div class="invalid-feedback" *ngIf="startDateField.invalid && startDateField.touched">
                                From Date is required
                            </div>
                        </div>
                    </div>

                    <!-- To Date - REQUIRED -->
                    <div class="col-4 mt-4">
                        <div class="form-floating datePicker">
                            <input type="text" placeholder="Process Date" class="form-control" bsDatepicker
                                [bsConfig]="{ isAnimated: true ,dateInputFormat: 'MM/DD/YYYY'}" [(ngModel)]="pagination.endDate"
                                name="endDate" #endDateField="ngModel" required
                                [class.is-invalid]="(endDateField.invalid && endDateField.touched) || isDateRangeInvalid()" #s3="bsDatepicker" readonly>
                            <label for="txtUrl">To Date <span class="text-danger">*</span></label>
                            <span class="input-group-text" (click)="s3.toggle()"><i class="fa fa-calendar"></i></span>
                            <div class="invalid-feedback" *ngIf="endDateField.touched && startDateField.touched && isDateRangeInvalid()">
                                To Date must be greater than From Date
                            </div>
                    
                            <div class="invalid-feedback" *ngIf="endDateField.invalid && endDateField.touched">
                                To Date is required
                            </div>
                    
                        </div>
                    </div>

                    <!-- Doc URL -->
                    <div class="col-12 mt-4">
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control" id="txtDocURL" placeholder="Doc URL" name="Doc URL"
                                [(ngModel)]="pagination.documentURL" [ngModelOptions]="{standalone: true}">
                            <label for="txtDocURL">Doc URL</label>
                        </div>
                    </div>

                    <!-- Buttons -->
                    <div class="col-12 mt-3">
                        <div class="d-flex">
                            <button class="btn btn-primary smallBtn" type="submit" (click)="Search(filterForm)"
                                style="height: 47px !important;">Search</button>
                            <button class="btn btn-default smallBtn" style="height: 47px !important;"
                                (click)="Reset()">Reset</button>
                            <button class="btn btn-primary smallBtn" (click)="GetCrawledDataToXLS(filterForm)"
                                style="height: 47px !important;">Export Crawled Data List</button>

                            <div class="form-check" style="margin-left: 20px;">
                                <input class="form-check-input" type="checkbox" id="wrapText" name="wrapText"
                                    [(ngModel)]="wrapText" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label p-0">Wrap Text</label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="pageHeader d-flex justify-content-between">
            <h1 class=" mb-4">Crawled Data Details</h1>
        </div>
        <div class="card-body rlSearchCard scrollTo">
            <div class="row m-0">
                <div class="col-12 table-responsive">
                    <table class="table table-bordered" [ngClass]="{'wrapTable':wrapText==true}">
                        <thead>
                            <tr style="border-bottom-width: 0px">
                                <th style="width: 5%; text-align: center; min-width: 220px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('UrlDetailID')"
                                        style="cursor: pointer;">
                                        <span>URL Configuration Master ID</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'UrlDetailID' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'UrlDetailID' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'UrlDetailID'"></i>
                                            <i class="fa fa-sort-asc"
                                                *ngIf="!pagination.columnName && 'UrlDetailID' === getDefaultSortColumn()"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('MasterSheetID')"
                                        style="cursor: pointer;">
                                        <span>Master Sheet ID</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'MasterSheetID' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'MasterSheetID' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'MasterSheetID'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('CrawledMasterDataID')"
                                        style="cursor: pointer;">
                                        <span>Crawled Master Data ID</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'CrawledMasterDataID' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'CrawledMasterDataID' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'CrawledMasterDataID'"></i>
                                        </span>
                                    </div>
                                </th>
                                <!-- <th style="width: 5%; text-align: center; min-width: 120px;">
                                                            <div class="d-flex justify-content-between align-items-center" (click)="sortData('Client')" style="cursor: pointer;">
                                                                <span>Client</span>
                                                                <span>
                                                                    <i class="fa"
                                                                        [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Client' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Client' && !pagination.ascending
                                                                        }"
                                                                        *ngIf="pagination.columnName === 'Client'"></i>
                                                                </span>
                                                            </div>
                                                        </th> -->
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Region')"
                                        style="cursor: pointer;">
                                        <span>Region</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Region' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Region' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Region'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Country')"
                                        style="cursor: pointer;">
                                        <span>Country</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Country' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Country' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Country'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Jurisdiction')"
                                        style="cursor: pointer;">
                                        <span>Jurisdiction</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Jurisdiction' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Jurisdiction' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Jurisdiction'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Regulator')"
                                        style="cursor: pointer;">
                                        <span>Regulator</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Regulator' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Regulator' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Regulator'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('DocType')"
                                        style="cursor: pointer;">
                                        <span>Doc Type</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'DocType' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'DocType' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'DocType'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Industry')"
                                        style="cursor: pointer;">
                                        <span>Industry</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Industry' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Industry' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Industry'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('UpdateType')"
                                        style="cursor: pointer;">
                                        <span>Update Type</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'UpdateType' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'UpdateType' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'UpdateType'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Language')"
                                        style="cursor: pointer;">
                                        <span>Language</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Language' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Language' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Language'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('SourceURL')"
                                        style="cursor: pointer;">
                                        <span>Source URL</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'SourceURL' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'SourceURL' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'SourceURL'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('PDFURL')"
                                        style="cursor: pointer;">
                                        <span>PDF URL</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'PDFURL' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'PDFURL' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'PDFURL'"></i>
                                        </span>
                                    </div>
                                </th>
                                 <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('TranslatedPDFURL')"
                                        style="cursor: pointer;">
                                        <span>Translated PDF URL</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'TranslatedPDFURL' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'TranslatedPDFURL' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'TranslatedPDFURL'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('DocID')"
                                        style="cursor: pointer;">
                                        <span>Doc ID</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'DocID' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'DocID' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'DocID'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('DocTitle')"
                                        style="cursor: pointer;">
                                        <span>Doc Title</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'DocTitle' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'DocTitle' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'DocTitle'"></i>
                                        </span>
                                    </div>
                                </th>
                                <!-- <th style="width: 5%; text-align: center; min-width: 200px;">
                                                            <div class="d-flex justify-content-between align-items-center" (click)="sortData('DocName')" style="cursor: pointer;">
                                                                <span>Doc Name</span>
                                                                <span>
                                                                    <i class="fa"
                                                                        [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'DocName' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'DocName' && !pagination.ascending
                                                                        }"
                                                                        *ngIf="pagination.columnName === 'DocName'"></i>
                                                                </span>
                                                            </div>
                                                        </th> -->
                                <th style="width: 5%; text-align: center; min-width: 200px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('DocURL')"
                                        style="cursor: pointer;">
                                        <span>Doc URL</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'DocURL' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'DocURL' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'DocURL'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 300px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('Summary')"
                                        style="cursor: pointer;">
                                        <span>Summary</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'Summary' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'Summary' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'Summary'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('FillingDate')"
                                        style="cursor: pointer;">
                                        <span>Filling Date</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'FillingDate' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'FillingDate' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'FillingDate'"></i>
                                        </span>
                                    </div>
                                </th>
                                <th style="width: 5%; text-align: center; min-width: 120px;">
                                    <div class="d-flex justify-content-between align-items-center" (click)="sortData('CrawledOn')"
                                        style="cursor: pointer;">
                                        <span>Crawled On</span>
                                        <span>
                                            <i class="fa" [ngClass]="{
                                                                            'fa-sort-asc': pagination.columnName === 'CrawledOn' && pagination.ascending,
                                                                            'fa-sort-desc': pagination.columnName === 'CrawledOn' && !pagination.ascending
                                                                        }" *ngIf="pagination.columnName === 'CrawledOn'"></i>
                                        </span>
                                    </div>
                                </th>
                               
                            </tr>
                            <tr>
                                <th style="width: 5%;min-width:200px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.urlDetailID"
                                                    (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                            
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                            
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeURLDetailID}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('urlDetailID', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.masterSheetID"
                                                    (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeMasterSheetID}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('masterSheetID', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.crawledMasterDataID"
                                                    (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeCrawledMasterDataID}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('crawledMasterDataID', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.region" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeRegion}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('region', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.country" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeCountry}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('country', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.jurisdiction"
                                                    (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeJurisdiction}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('jurisdiction', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.regulator" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeRegulator}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('regulator', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.docType" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeDocType}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('docType', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.industry" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeIndustry}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('industry', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.updateType" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeUpdateType}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('updateType', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.language" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeLanguage}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('language', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.sourceURL" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeSourceURL}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('sourceURL', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.pdfURL" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activePDFURL}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('pdfURL', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>

                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.TranslatedPDFURL" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeTranslatedPDFURL}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('TranslatedPDFURL', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.docID" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeDocID}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('docID', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.docTitle" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeDocTitle}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('docTitle', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.docURL" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeDocURL}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('docURL', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.summary" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeSummary}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('summary', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.fillingDate"
                                                    (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeFillingDate}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('fillingDate', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
                            
                                <th style="width: 5%;min-width:130px;">
                                    <form (ngSubmit)="$event.preventDefault()">
                                        <div class="d-flex">
                                            <div class="form-floating flex-grow-1">
                                                <input type="text" class="form-control filterSearch" placeholder="Search..."
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filters.crawledOn" (input)="applyFilters()">
                                                <label>Search</label>
                                            </div>
                                            <div class="btn-group moreOptWrapper" dropdown [autoClose]="true" [insideClick]="true">
                                                <button dropdownToggle type="button" class="dropdown-toggle filterToggle" title="More options">
                                                    <i class="fa fa-filter filterIcon"></i>
                                                </button>
                                                <ul *dropdownMenu class="dropdown-menu RLFilter">
                                                    <li *ngFor="let item of columnDropdownFilter; let i = index"
                                                        [ngClass]="{'active': item.activeCrawledOn}">
                                                        <a class="dropdown-item" (click)="applyFilterOption('crawledOn', i)">
                                                            {{ item.name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </form>
                                </th>
            
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="pagedCrawledData?.length==0">
                                <td attr.colspan="{{colSpan}}" class="text-center"
                                    style="padding-top: 70px; padding-bottom: 70px;">
                                    <h6 class="text-center" style="color: red;" *ngIf="crawledDataList?.length==0">
                                        No Record Found
                                    </h6>
                                </td>
                            </tr>
                            <tr *ngFor="let data of pagedCrawledData;let i=index;"
                                [style.background-color]="data?.ColorCode!='rgb(0 0 0)' || data?.ColorCode!='#000000' ? data?.ColorCode : null">

                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.UrlDetailID}}">
                                    {{data?.UrlDetailID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.MasterSheetID}}">
                                    {{data?.MasterSheetID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledMasterDataID}}">
                                    {{data?.CrawledMasterDataID}}
                                </td>
                                <!-- <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Client}}">
                                    {{data?.Client}}
                                </td> -->
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Region}}">
                                    {{data?.Region}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Country}}">
                                    {{data?.Country}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.Jurisdiction}}">
                                    {{data?.Jurisdiction}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Regulator}}">
                                    {{data?.Regulator}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.DocType}}">
                                    {{data?.DocType}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Industry}}">
                                    {{data?.Industry}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.UpdateType}}">
                                    {{data?.UpdateType}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Language}}">
                                    {{data?.Language}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.SourceURL}}">
                                    <button *ngIf="data?.SourceURL" type="button"
                                        style="border: none;margin-right: 5px;"
                                        (click)="copyToClipboard(data?.SourceURL)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    <a href="javascript:void(0)" title="{{data?.SourceURL}}"
                                        (click)="NavigateToSourceUrl(data?.UrlDetailID, data.SourceURL)">{{data?.SourceURL}}</a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.PDFURL}}">
                                    <button *ngIf="data?.PDFURL" type="button" style="border: none;margin-right: 5px;"
                                        (click)="copyToClipboard(data?.PDFURL)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    <a *ngIf="data?.PDFURL" href="{{data?.PDFURL}}" target="_blank">{{data?.PDFURL}}</a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.TranslatedPDFURL}}">
                                    <button *ngIf="data?.TranslatedPDFURL" type="button" style="border: none;margin-right: 5px;"
                                        (click)="copyToClipboard(data?.TranslatedPDFURL)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    <a *ngIf="data?.TranslatedPDFURL" href="{{data?.TranslatedPDFURL}}" target="_blank">{{data?.TranslatedPDFURL}}</a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.DocID}}">
                                    {{data?.DocID}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.DocTitle}}">
                                    {{data?.DocTitle}}
                                </td>
                                <!-- <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.DocName}}">
                                    {{data?.DocTitle}}
                                </td> -->
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.DocURL}}">
                                    <button *ngIf="data?.DocURL" type="button" style="border: none;margin-right: 5px;"
                                        (click)="copyToClipboard(data?.DocURL)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    <a *ngIf="data?.DocURL" href="{{data?.DocURL}}" target="_blank">{{data?.DocURL}}</a>
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.Summary}}">
                                    <button *ngIf="data?.Summary" type="button" style="border: none;margin-right: 5px;"
                                        (click)="copyToClipboard(data?.Summary)">
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                    {{data?.Summary}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis" title="{{data?.FillingDate}}">
                                    {{data?.FillingDate}}
                                </td>
                                <td style="width: 5%; text-align:center" class="ellipsis"
                                    title="{{data?.CrawledOn|date:'MM/dd/YYYY'}}">
                                    {{data?.CrawledOn|date:'MM/dd/YYYY'}}
                                </td>

                                
                            </tr>
                            <tr *ngIf="crawledDataList?.length<=4 && crawledDataList?.length!=0">
                                <td attr.colspan="{{colSpan}}" class="text-center" style="padding-bottom: 142px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row clear-fix col-12 mt-2">
                <div class="col-3 ps-4 d-flex">
                    <div class="form-floating p-1">
                        <select class="form-select form-control paginationDropdown" id="floatingSelect"
                            [(ngModel)]="pagination.pageLength" (change)="GetWorkbenchByPageLength()">
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                            <option value="500">500</option>
                            <option value="750">750</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>
                    <label for="floatingSelect" class="mt-2 pt-2 ms-2">Items per page</label>
                </div>

                <div class="col-9 m-0 float-right">
                    <div class="row p-0">

                        <div class="col-4 mt-3 p-0 text-center">
                            <h6 *ngIf="totalRecordsForPagination != 0">
                                {{ totalRecordsForPagination }} crawled items found
                            </h6>
                        </div>

                        <div class="col-8 p-0 m-0" *ngIf="totalPages > 1">
                            <app-pagination [totalPages]="totalPages" [currentPage]="currentPage"
                                (pageChanged)="setPage($event)">
                            </app-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<app-loader [showLoader]="showLoader"></app-loader>
<notifier-container></notifier-container>